<section class="w-full gap-2">
  <div class="w-full">
    <h1 class="text-2xl font-bold">اجاره اقامتگاه</h1>
  </div>
  <div class="w-full mt-5 flex justify-between flex-wrap">
    <div class="tab flex justify-start gap-x-2 overflow-x-auto whitespace-nowrap py-2">
      <div class="border border-solid rounded-3xl px-3 py-1.5 cursor-pointer"
        (click)="selectedTabName = item.Name;handledActiveTabs(item)"
        [ngClass]="selectedTabName === item.Name ? 'border-blue-500 text-blue-500' : ''"
        *ngFor="let item of _tabsTitles;let index = index">
        <span class="text-sm !font-medium">{{item.Name}}</span>
      </div>

    </div>
    <div class="hidden lg:block">
      <div class="flex float-start border  border-solid rounded-full px-1 mx-2 cursor-pointer"
        [ngClass]="showArrowPrev ? 'active:bg-blue-500 active:text-white' : 'opacity-50 cursor-default'"
        (click)="previousSlide()">
        <i class="ico-Right text-3xl"></i>
      </div>
      <div class="flex float-start border  border-solid rounded-full px-1 cursor-pointer"
        [ngClass]="showArrowNext ? 'active:bg-blue-500 active:text-white' : 'opacity-50 cursor-default'"
        (click)="nextSlide()">
        <i class="ico-Left text-3xl"></i>
      </div>

    </div>

  </div>
  <div class="w-full mt-4" id="PopularHotels">
    <ng-container *ngIf="!resetSwiper()">

      <swiper [config]="sliderConfigs!" (slideChange)="onSlideChange($event)" #swiper>
        <ng-template swiperSlide *ngFor="let cardData of _dataSource, let i = index">
          <iho-hotels-card [ecolodgeType]="2"  [dataSource]="cardData" [type]="2" [@fadeAnimation] />
        </ng-template>
      </swiper>

    </ng-container>

    <ng-container *ngIf="resetSwiper()">

      <swiper [config]="sliderConfigs!" (slideChange)="onSlideChange($event)" #swiper>
        <ng-template swiperSlide *ngFor="let i of [].constructor(6)">
          <iho-hotel-card-skeleton class="animate-pulse" [@fadeAnimation] />
        </ng-template>
      </swiper>

    </ng-container>



  </div>
</section>
